var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    ref: "sidebar",
    attrs: {
      id: "sidebar-estimate",
      title: _vm.$t("Dados da entrega"),
      show: _vm.showSidebar,
      fetching: _vm.fetching,
      saving: _vm.saving,
      "confirm-button-text": _vm.$t("Reiniciar entrega"),
      "cancel-button-text": _vm.$t("Fechar"),
      "extra-buttons": [
        {
          event: "cancelDelivery",
          variant: "danger",
          text: _vm.$t("Cancelar entrega"),
          icon: "x-circle",
          hide:
            !_vm.order.deliveryOrder ||
            _vm.order.deliveryOrder.status === "canceled" ||
            _vm.order.deliveryOrder.status === "delivered",
        },
      ].filter(function (btn) {
        return !btn.hide
      }),
      width: "40%",
    },
    on: {
      hidden: _vm.hide,
      save: _vm.restartDelivery,
      cancelDelivery: _vm.cancelDelivery,
    },
    scopedSlots: _vm._u(
      [
        _vm.order.deliveryOrder || _vm.selectedDispatch
          ? {
              key: "content",
              fn: function () {
                return [
                  _vm.order
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  value:
                                    "#" +
                                    _vm.order.id +
                                    " - " +
                                    _vm.order.customer.name,
                                  type: "label",
                                  label: _vm.$t("Pedido"),
                                },
                              }),
                              !_vm.order.deliveryOrder && _vm.selectedDispatch
                                ? [
                                    _c("FormulateInput", {
                                      attrs: {
                                        value:
                                          _vm.selectedDispatch.supplierName ||
                                          "-",
                                        type: "label",
                                        label: _vm.$t("Serviço de entrega"),
                                      },
                                    }),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value:
                                          _vm.selectedDispatch.statusLabel ||
                                          "-",
                                        type: "label",
                                        label: _vm.$t("Status da entrega"),
                                      },
                                    }),
                                    _vm.selectedDispatch.supplierOrderId
                                      ? _c("FormulateInput", {
                                          attrs: {
                                            value:
                                              _vm.selectedDispatch
                                                .supplierOrderId,
                                            type: "label",
                                            label: _vm.$t(
                                              "Id do pedido de entrega"
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.pickupAddressLabel,
                                        type: "label",
                                        label: _vm.$t("Local de retirada"),
                                      },
                                    }),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.deliveryAddressLabel,
                                        type: "label",
                                        label: _vm.$t("Local de entrega"),
                                      },
                                    }),
                                  ]
                                : [
                                    _c("FormulateInput", {
                                      attrs: {
                                        type: "label",
                                        label: _vm.$t(
                                          "Id do pedido de entrega"
                                        ),
                                      },
                                      model: {
                                        value: _vm.order.deliveryOrderId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.order,
                                            "deliveryOrderId",
                                            $$v
                                          )
                                        },
                                        expression: "order.deliveryOrderId",
                                      },
                                    }),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.order.deliverySupplier
                                          ? _vm.order.deliverySupplier.name
                                          : "-",
                                        type: "label",
                                        label: _vm.$t("Serviço de entrega"),
                                      },
                                    }),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.$t(
                                          "PAY_BOX_SALE.DELIVERY_STATUS." +
                                            _vm.order.deliveryOrder.status
                                        ),
                                        type: "label",
                                        label: _vm.$t("Status da entrega"),
                                      },
                                    }),
                                    _vm.order.deliveryOrder.driverInfo &&
                                    _vm.order.deliveryOrder.driverInfo
                                      .vehicleInfo
                                      ? _c("FormulateInput", {
                                          attrs: {
                                            value:
                                              _vm.order.deliveryOrder.driverInfo
                                                .name +
                                              " - " +
                                              _vm.$t("Placa/Cor") +
                                              ": " +
                                              _vm.order.deliveryOrder.driverInfo
                                                .vehicleInfo.plateNo +
                                              " / " +
                                              _vm.order.deliveryOrder.driverInfo
                                                .vehicleInfo.color +
                                              " - " +
                                              _vm.$t("Telefone") +
                                              ": " +
                                              _vm.$options.filters.phone(
                                                _vm.order.deliveryOrder
                                                  .driverInfo.phone
                                              ),
                                            type: "label",
                                            label: _vm.$t(
                                              "Dados do entregador"
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.pickupVerifyCodeLabel,
                                        type: "label",
                                        icons: _vm.pickupVerifyCodeIcons,
                                        label: _vm.$t(
                                          "Código de verificação para o motorista"
                                        ),
                                        instruction: _vm.$t(
                                          "Código de verificação que o motorista deverá fornecer à loja no momento da retirada dos produtos"
                                        ),
                                      },
                                      on: {
                                        "toggle-pickup-verify-code": function (
                                          $event
                                        ) {
                                          _vm.showPickupVerifyCode =
                                            !_vm.showPickupVerifyCode
                                        },
                                      },
                                    }),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.dropoffVerifyCodeLabel,
                                        type: "label",
                                        icons: _vm.dropoffVerifyCodeIcons,
                                        label: _vm.$t(
                                          "Código de verificação para o cliente"
                                        ),
                                        instruction: _vm.$t(
                                          "Código de verificação que o cliente deverá fornecer ao entregador no momento da entrega"
                                        ),
                                      },
                                      on: {
                                        "toggle-dropoff-verify-code": function (
                                          $event
                                        ) {
                                          _vm.showDropoffVerifyCode =
                                            !_vm.showDropoffVerifyCode
                                        },
                                      },
                                    }),
                                    _vm.order.deliveryOrder.verifyInfo &&
                                    _vm.order.deliveryOrder.verifyInfo
                                      .returnVerifyCode
                                      ? _c("FormulateInput", {
                                          attrs: {
                                            value: _vm.order.deliveryOrder
                                              .verifyInfo
                                              ? _vm.order.deliveryOrder
                                                  .verifyInfo.returnVerifyCode
                                              : "-",
                                            type: "label",
                                            label: _vm.$t(
                                              "Código de verificação para devolução"
                                            ),
                                            instruction: _vm.$t(
                                              "Código de verificação que a loja deverá fornecer ao entregador no momento da devolução"
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.lastEstimateLabel,
                                        type: "label",
                                        label: _vm.$t(
                                          "Distância / Tempo de entrega"
                                        ),
                                      },
                                    }),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value:
                                          _vm.store.address.publicPlace +
                                          ", " +
                                          _vm.store.address.number +
                                          " - " +
                                          _vm.store.address.neighborhood,
                                        type: "label",
                                        label: _vm.$t("Local de retirada"),
                                      },
                                    }),
                                    _c("FormulateInput", {
                                      attrs: {
                                        value:
                                          _vm.order.deliveryAddress
                                            .publicPlace +
                                          ", " +
                                          _vm.order.deliveryAddress.number +
                                          " - " +
                                          _vm.order.deliveryAddress
                                            .neighborhood,
                                        type: "label",
                                        label: _vm.$t("Local de entrega"),
                                      },
                                    }),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }